import { memo, useCallback, useContext, useEffect, useState } from "react";
import { EmissaoContext } from "../../../contexts/EmissaoContext";
import { Grid, TextField, Tooltip } from "@material-ui/core";
import { getTaxNoteItem } from "../../../../../../repositories/qerpapi/v3/empresa/notafiscal";
import { QueryParamsContext } from "../../../../../../context/QueryParamsContext";
import useEmissaoController from "../../../controllers/EmissaoController";
import SelectErp from "../../../../../../components/basics/SelectErp";
import MaskService from "../../../../../../utils/mask/maskService";
import { FiberManualRecord } from "@material-ui/icons";
import TableDefault from "../../../../../../components/grid/TableDefault";
import { notify } from "../../../../../../utils/notify";

const PurchaseItemsTable = () => {
  const { queryParams } = useContext(QueryParamsContext);

  const {
    selectedPurchaseNf,
    headerCfop,
    nfeListCfop,
    selectedPurchaseItems,
    setSelectedPurchaseItems,
  } = useContext(EmissaoContext);

  const { getCodeBarProduct, getDescriptionProduct } = useEmissaoController();

  const [taxNoteItemsData, setTaxNoteItemsData] = useState([]);
  const [tableItemsLoading, setTableItemsLoading] = useState(false);

  const handleChangeItemCfop = (e, value) => {
    if (e) {
      const copy = [...taxNoteItemsData];
      const copySelected = [...selectedPurchaseItems];

      const newItems = (copy || []).map((item) => {
        if (item.id === value.id) {
          item.cfop = e.cfop;
        }
        return item;
      });

      const newSelectedItems = (copySelected || []).map((item) => {
        if (item.id === value.id) {
          item.cfop = e.cfop;
        }
        return item;
      });
      setTaxNoteItemsData(newItems);
      setSelectedPurchaseItems(newSelectedItems);
    }

    return e;
  };

  const handleChangeUnitaryValue = (e, value) => {
    const recivedValue = e?.target?.value || "0";

    const copyList = [...taxNoteItemsData];
    const copySelected = [...selectedPurchaseItems];

    const newUnitaryValue = MaskService.toMask("decimal", recivedValue, 5);
    const newValueNumber = MaskService.removeMaskDecimal(newUnitaryValue, 5);

    const newItems = (copyList || []).map((item) => {
      if (item.id === value.id) {
        item.unitaryValueField = newUnitaryValue;
        item.vl_unitario = newValueNumber;
        item.vl_total = item.quantidade * newValueNumber;
      }
      return item;
    });

    const newSelectedItems = (copySelected || []).map((item) => {
      if (item.id === value.id) {
        item.unitaryValueField = newUnitaryValue;
        item.vl_unitario = newValueNumber;
        item.vl_total = item.quantidade * newValueNumber;
      }
      return item;
    });

    setTaxNoteItemsData(newItems);
    setSelectedPurchaseItems(newSelectedItems);

    return e;
  };

  const handleChangeItemQuantity = (e, value) => {
    const recivedValue = e?.target?.value || "0";

    const copyList = [...taxNoteItemsData];
    const copySelected = [...selectedPurchaseItems];

    const newQuantityValue = MaskService.toMask("decimal", recivedValue, 4);
    const newValueNumber = MaskService.removeMaskDecimal(newQuantityValue, 4);

    const newItems = (copyList || []).map((item) => {
      if (item.id === value.id) {
        item.itemQuantityField = newQuantityValue;
        item.quantidade = newValueNumber;
        item.vl_total = newValueNumber * item.vl_unitario;
      }
      return item;
    });

    const newSelectedItems = (copySelected || []).map((item) => {
      if (item.id === value.id) {
        item.itemQuantityField = newQuantityValue;
        item.quantidade = newValueNumber;
        item.vl_total = newValueNumber * item.vl_unitario;
      }
      return item;
    });

    setTaxNoteItemsData(newItems);
    setSelectedPurchaseItems(newSelectedItems);

    return e;
  };

  const columnsItemsSearch = [
    {
      label: "Descrição",
      id: "descricao",
      style: { minWidth: 200 },
      format: (value) => {
        const description = getDescriptionProduct(
          value,
          "WizardEmissaoController"
        );
        var statusMsg = "";
        var color = "";

        if (value.tipovenda === "devolucao" || value.tipovenda === "defeito") {
          statusMsg = "Devolução / Defeito";
          color = "red";
        } else if (value.travarnf === "1") {
          statusMsg = "Produto travado no cadastro";
          color = "yellow";
        } else if (value.reclassificado === "S") {
          statusMsg = "Produto reclassificado";
          color = "#A52A2A";
        }
        if (statusMsg) {
          return (
            <>
              <Tooltip title={statusMsg} aria-label={statusMsg}>
                <span style={{ pointerEvents: "all" }}>
                  <FiberManualRecord style={{ color: color }} />
                </span>
              </Tooltip>
              <span style={{ paddingLeft: "4px", verticalAlign: "super" }}>
                {description}
              </span>
            </>
          );
        } else {
          return description;
        }
      },
    },
    {
      label: "Codigo",
      format: (value) => {
        return <>{getCodeBarProduct(value, "WizardEmissaoController")}</>;
      },
    },
    { label: "NCM", id: "ncm" },
    {
      label: "CFOP",
      align: "center",
      style: { minWidth: 140 },
      format: (value) => {
        let cfopValue =
          nfeListCfop.find((item) => item.cfop === value.cfop) || null;

        const cfopBackgroundColor = () => {
          if (!!cfopValue) {
            if (parseInt(cfopValue.cfop) === parseInt(headerCfop))
              return "#bcdccf";
            else return "#fff9b3";
          } else {
            return "rgba(244, 89, 100, 0.3)";
          }
        };

        return (
          <SelectErp
            onChange={(e) => {
              handleChangeItemCfop(e, value);
            }}
            variant="outlined"
            optionsList={nfeListCfop || []}
            descriptionField="cfop"
            value={cfopValue}
            style={{ backgroundColor: cfopBackgroundColor() }}
          />
        );
      },
    },
    {
      label: "Qtde",
      style: { minWidth: 120 },
      format: (value) => {
        return (
          <TextField
            onChange={(e) => {
              handleChangeItemQuantity(e, value);
            }}
            variant="outlined"
            value={value.itemQuantityField}
          />
        );
      },
    },
    {
      label: "Vlr Unitário",
      style: { minWidth: 125 },
      format: (value) => {
        return (
          <TextField
            onChange={(e) => {
              handleChangeUnitaryValue(e, value);
            }}
            variant="outlined"
            value={value.unitaryValueField}
          />
        );
      },
    },
    {
      label: "Vlr Total",
      style: { minWidth: 105 },
      format: (value) =>
        `R$ ${
          value.vl_total
            ? MaskService.toMask(
                "decimal",
                parseFloat(value.vl_total).toFixed(2)
              )
            : "-"
        }`,
    },
  ];

  const handleGetTaxNotesItems = useCallback(async () => {
    try {
      setTableItemsLoading(true);
      const taxNoteIds = (selectedPurchaseNf || []).map(
        (taxNote) => taxNote?.id
      );

      const itemsCallback = await getTaxNoteItem({
        companyId: queryParams.empresa_id,
        filters: {
          idnotafiscal: `in:${taxNoteIds}`,
        },
        perPage: "999",
      });

      if (!itemsCallback?.success)
        return notify(
          "Erro ao buscar os itens, por favor repita o processo anterior de seleção de NFe."
        );

      const newCfop = (nfeListCfop || []).find(
        (item) => item.cfop === headerCfop
      );

      const copyData = (itemsCallback?.data || []).map((item) => ({
        ...item,
        originalUnitaryValue: item?.vl_unitario || 0,
        originalQuantity: item?.quantidade || 0,
        unitaryValueField: MaskService.toMask(
          "decimal",
          parseFloat(item?.vl_unitario || "0").toFixed(5),
          5
        ),
        itemQuantityField: MaskService.toMask(
          "decimal",
          parseFloat(item?.quantidade || "0").toFixed(4),
          4
        ),
        ...(newCfop?.cfop ? { cfop: newCfop?.cfop } : {}),
      }));

      setTaxNoteItemsData(copyData);
    } catch (error) {
      console.error("Get Nfe Items Error: ", error);
    } finally {
      setTableItemsLoading(false);
    }
    // eslint-disable-next-line
  }, [headerCfop, queryParams.empresa_id, selectedPurchaseNf]);

  useEffect(() => {
    if (!queryParams?.empresa_id) return;

    handleGetTaxNotesItems();
  }, [handleGetTaxNotesItems, queryParams?.empresa_id]);

  useEffect(() => {
    setSelectedPurchaseItems([]);
  }, [setSelectedPurchaseItems]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TableDefault
          stickyHeader
          loading={tableItemsLoading}
          values={taxNoteItemsData}
          columns={columnsItemsSearch}
          allChecked
          maxHeight="50vh"
          rowsPerPage={10}
          selectable={true}
          selected={selectedPurchaseItems}
          setSelected={setSelectedPurchaseItems}
          selectedByRow={false}
        />
      </Grid>
    </Grid>
  );
};

export default memo(PurchaseItemsTable);
